<template>
  <div class="text-left">
    <form @submit.prevent="searchUsers">
      <div class="form-row">
        <div class="form-group col">
          <label for="firstName">First Name</label>
          <input
            type="text"
            class="form-control"
            id="firstName"
            placeholder="First Name"
            v-model="firstName"
          />
        </div>
        <div class="form-group col">
          <label for="lastName">Last Name</label>
          <input
            type="text"
            class="form-control"
            id="lastName"
            placeholder="Last Name"
            v-model="lastName"
          />
        </div>
        <div class="form-group col">
          <label for="group">Group</label>
          <select class="form-control" id="group" v-model="group">
            <option value="-1">
              All Groups
            </option>
            <option
              v-for="group in accountGroups"
              :key="group.AccountGroup_Id"
              v-bind:value="group.AccountGroup_Id"
            >
              {{ group.Name }}
            </option>
          </select>
        </div>
        <div class="form-group col-auto">
          <label style="visibility: hidden;">Hide</label>
          <button type="submit" class="btn btn-primary d-block">Search</button>
        </div>
      </div>
    </form>
    <div style="height: 1px; background-color: gray; " />
    <div class="row">
      <div class="col">
        <small class="text-secondary">Name</small>
      </div>
      <div class="col">
        <small class="text-secondary">Email</small>
      </div>
      <div class="col">
        <small class="text-secondary">Organization</small>
      </div>
      <div class="col-auto">
        <button class="btn btn-link" style="visibility: hidden">Account</button>
      </div>
    </div>
    <div
      v-for="(user, index) in users"
      :key="user.UserId"
      class="pt-2 row"
      v-bind:class="{ 'light-background': index % 2 === 1 }"
    >
      <div class="col">
        <p class="pointer pt-2 btn-link" v-on:click="editUser(user)">
          {{ user.First_Name }} {{ user.Last_Name }}
        </p>
      </div>
      <div class="col">
        <p class="pt-2">{{ user.Email }}</p>
      </div>
      <div class="col">
        <p class="pt-2">{{ user.Organization.Name }}</p>
      </div>
      <div class="col-auto">
        <button
          class="btn btn-link"
          v-on:click="$emit('selectedAccount', user.Account_Id)"
        >
          Account
        </button>
      </div>
    </div>
    <div class="text-center mt-2">
      <button
        v-if="users.length < userCount"
        class="btn btn-primary"
        v-on:click="loadUsers"
      >
        Load More
      </button>
    </div>
    <EditAccountUserModal
      v-bind:UserToEdit="userToEdit"
      v-bind:Organizations="orgsForUser"
      @editedUser="userEdited"
    />
  </div>
</template>

<script>
import $ from "jquery";
import EditAccountUserModal from "@/modals/ManageAccounts/EditAccountUserModal";

export default {
  name: "UserList",
  components: {
    EditAccountUserModal
  },
  data() {
    return {
      users: [],
      firstName: "",
      lastName: "",
      group: -1,
      limit: 10,
      userCount: 0,
      accountGroups: [],
      orgsForUser: [],
      userToEdit: null
    };
  },
  watch: {
    group: async function() {
      await this.searchUsers();
    }
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    await this.searchUsers();
    this.accountGroups = await this.$getAccountGroups();
  },
  methods: {
    async searchUsers() {
      var view = this;
      view.$store.commit("updateLoading", true);
      view.userCount = await this.$getAccountManagementUserCount(
        view.firstName,
        view.lastName,
        view.group != -1 ? view.group : null
      );
      view.users = [];
      await this.loadUsers();
      view.$store.commit("updateLoading", false);
    },
    async loadUsers() {
      var view = this;
      await this.$getAccountManagementUsers(
        view.firstName,
        view.lastName,
        view.group != -1 ? view.group : null,
        view.users.length,
        view.limit
      ).then(loadedUsers => {
        if (view.users.length == 0) {
          view.users = loadedUsers;
        } else {
          loadedUsers.forEach(loadedUser => {
            view.users.push(loadedUser);
          });
        }
      });
    },
    async editUser(user) {
      var view = this;
      view.userToEdit = user;
      view.$store.commit("updateLoading", true);
      await view.$getAccountOrganizations(user.Account_Id).then(res => {
        view.$store.commit("updateLoading", false);
        view.orgsForUser = res.Organizations.filter(
          o => o.Organization_Id != 1
        );
      });
      $("#editAccountUserModal").modal("show");
    },
    userEdited(editedUser) {
      var editingIndex = this.users.findIndex(
        u => u.User_Id == editedUser.User_Id
      );
      this.$set(this.users, editingIndex, editedUser);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.light-background {
  background-color: #00000011;
}
</style>
